<template>
    <div class="ui-modal">
        <a-dialog
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="showModal"
            @open="openModal()"
            :width="width"
            >
            <div class="ph-modal-header clearfix" slot="title">
                <span class="left-bar"></span>
                <span>{{title}}</span>
                <i class="fr iconfont icon-chahao" @click="cancel()"></i>
            </div>
            <!-- 插槽内容 -->
            <slot name="centerSlot"></slot>

            <span slot="footer" class="dialog-footer" v-if="!hideModalBtn">
                <slot name="footer"></slot>
                <span v-if="!$scopedSlots.footer">
                    <a-button class="default-btn" v-loading="loading" @click="cancel()">{{modalBtnTextList? modalBtnTextList[0] : '取 消'}}</a-button>
                    <a-button class="default-btn primary" v-loading="loading" type="primary" @click="sure()">{{modalBtnTextList? modalBtnTextList[1] : '确 定'}}</a-button>
                </span>
            </span>
        </a-dialog>
    </div>
</template>

<script>
export default {
    name : 'UiModal',
    props : {
        title : {
            type : String,
            default : '提示'
        },
        width : {
            type : String,
            default : '30%',
        },
        showModal : {
            type : Boolean,
            default : false,
        },
        loading : {
            type : Boolean,
            default : false,
        },
        modalBtnTextList : {
            type : Array,
            default : () => []
        },
        hideModalBtn : {
            type : Boolean,
            default : false
        }
    },
    mounted () {
        
    },
    data () {
        return {

        }
    },
    methods : {
        switchShowFlag (type) {
            // 考虑到可能要做些特殊处理，不再采用此方法
            // this.$emit('update:showModal',type);
        },
        // 开启弹窗
        openModal () {
            setTimeout(() => this.$emit('open'),0);
        },

        // 点击了确定按钮
        sure () {
            this.$emit('sureCb');
        },
        // 点击了关闭按钮
        cancel (done) {
            this.$emit('cancelCb');
        }
    }
}
</script>

<style lang="less" scoped>
/deep/ .a-dialog{
    border-radius:8px;
}
/deep/ .a-dialog__header{
    border-radius:8px;
    // padding:15px 20px 15px;
    padding:0 20px;
}
/deep/ .modal-title{
    font-size:24px;
    font-weight:bold;
}
.ph-modal-header{
    height:53px;
    line-height: 53px;
    font-size:14px;
    color:#44495A;
    border-bottom:1px solid #E4E5EC;
    font-weight: 600;
    // 左侧竖杠
    .left-bar{
        display:inline-block;
        width:3px;
        height:12px;
        background:#3D5DB1;
        border-radius:2px;
        margin-right:8px;
        vertical-align: middle;
    }
    i{
        font-weight:bold;
        font-size:24px;
        cursor: pointer;
    }
}
</style>